module.exports = new __parcel__URL__("objective_follow_button.780c5920.png").toString();